module.exports = __webpack_public_path__ + "jtails-build/img/checkout-fail.0a52ea67.svg";